export const ALL_SLOT_REQUEST = "ALL_SLOT_REQUEST"
export const ALL_SLOT_SUCCESS = "ALL_PAYMENT_SUCCESS"
export const ALL_SLOT_FAIL = "ALL_PAYMENT_FAIL"

export const UPDATE_SLOT_REQUEST = "UPDATE_SLOT_REQUEST"
export const UPDATE_SLOT_SUCCESS = "UPDATE_SLOT_SUCCESS"
export const UPDATE_SLOT_FAIL = "UPDATE_SLOT_FAIL"

export const GET_PLAN_REQUEST = "GET_PLAN_REQUEST"
export const GET_PLAN_SUCCESS = "GET_PLAN_SUCCESS"
export const GET_PLAN_FAIL = "GET_PLAN_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS";